<template>
  <teleport to="body">
    <div class="web_dialog">
      {{ modalName }}
      <Dialog
        :header="dialogData.header"
        :visible="dialogData.message !== '' && modalName === 'MsgDialog'"
        :style="{width: `${dialogData.width}px`}"
        :modal="true"
      >
        <div class="confirmation-content">
          <i
            :class="icon"
            :style="{fontSize: `${dialogData.iconSize}rem`}"
          />
          <span> {{ dialogData.message }} </span>
        </div>

        <template #footer>
          <Button
            v-if="dialogData.dialogType === 'confirm'"
            :label="dialogData.rejectLabel"
            class="p-button-text"
            @click="closeModal"
          />
          <Button
            v-if="dialogData.dialogType !== 'notification'"
            :label="dialogData.acceptLabel"
            autofocus
            @click="confirmAction"
          />
        </template>
      </Dialog>
    </div>
  </teleport>
</template>

<script>
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { useStore } from 'vuex';
import { computed } from 'vue';

export default {
  name: 'MsgDialog',
  components: {
    Dialog,
    Button
  },
  props: {
    width: {
      type: [Number, String],
      default () {
        return 300;
      }
    },
    header: {
      type: String,
      default () {
        return '確認視窗';
      }
    },
    message: {
      type: String,
      default () {
        return '';
      }
    },
    icon: {
      type: String,
      default () {
        return '';
      }
    },
    iconSize: {
      type: [Number, String],
      default () {
        return 1;
      }
    },
    acceptLabel: {
      type: String,
      default () {
        return '確認';
      }
    },
    rejectLabel: {
      type: String,
      default () {
        return '取消';
      }
    },
    dialogType: {
      type: String,
      default () {
        // confirm 顯示兩顆紐
        // alert 顯示一顆按鈕 (帶入 acceptLabel)
        // notification 都不顯示按鈕
        return 'confirm';
      }
    }
  },
  emits: ['modal-action'],
  setup (props, { emit }) {
    const store = useStore();
    const modalName = computed(() => store.state.dialog.modalName);

    const dialogData = computed(() => {
      const returnData = {};
      Object.keys(props).forEach((item, key) => {
        returnData[item] = store.state.dialog.dialogItem[item] || props[item];
      });

      return returnData;
    });

    const closeModal = () => {
      store.commit('CLOSE_DIALOG');
    };

    const confirmAction = () => {
      emit('modal-action', store.state.dialog.actionType);
    };

    return {
      dialogData,
      closeModal,
      confirmAction,
      modalName
    };
  }
};
</script>
